<div class="flex min-h-screen flex-col">
    <app-shared-header
        appName="GBR EMA Cloud"
        [homeAriaLabel]="'header.app-name-homepage' | translate"
        [selectedLang]="selectedLang()"
        [user]="user()"
        (languageChanged)="changeLanguage($event)"
    />
    <main class="content flex grow flex-col">
        <router-outlet />
    </main>
    <app-shared-footer />
</div>
